var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import { HomeRouter } from 'routes';
import { Map } from 'immutable';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import MenuList from '@material-ui/core/MenuList';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import ImageCarousel from './ImageCarousel/promopg';
import EditProfile from 'components/FirstLogin';
import './frontpg.css';
// - Import actions
// - Import actions
import { imageGalleryActions, postActions, userActions, globalActions, circleActions, notifyActions } from 'src/store/actions';
var drawerWidth = 305;
var styles = function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            width: '100%',
            marginTop: theme.spacing.unit * .2,
            zIndex: 1,
            overflow: 'hidden',
            margin: 'auto'
        },
        appFrame: {
            position: 'relative',
            display: 'flex',
            width: '100%',
            height: '100%',
        },
        navIconHide: (_a = {},
            _a[theme.breakpoints.up('md')] = {
                display: 'none',
            },
            _a),
        drawerHeader: theme.mixins.toolbar,
        drawerPaper: (_b = {
                maxWidth: drawerWidth,
                width: drawerWidth
            },
            _b[theme.breakpoints.up('md')] = {
                width: drawerWidth,
                position: 'absolute',
                height: '50%',
                overflow: 'hidden'
            },
            // backgroundColor: '#1b1b1b',    // background of side menu
            _b.backgroundImage = 'linear-gradient(#232526,#414345)',
            _b.borderRight = 0,
            _b.borderRadius = '15px',
            _b),
        drawerPaperLarge: (_c = {
                width: drawerWidth
            },
            _c[theme.breakpoints.up('md')] = {
                width: drawerWidth,
                height: '35%',
                overflow: 'hidden'
            },
            _c.top = 65,
            // backgroundColor: '#1b1b1b',    // background of side menu
            _c.backgroundImage = 'linear-gradient(#232526,#414345)',
            _c.borderRight = 0,
            _c.borderRadius = '15px',
            _c),
        menu: {
            height: '100%',
        },
        content: (_d = {
                // backgroundImage: `url(https://media.idownloadblog.com/wp-content/uploads/2016/01/bokeh-snow-flare-water-white-splash-pattern-9-wallpaper.jpg)`,   // background of post component 
                // backgroundImage: 'linear-gradient(217deg, rgba(255,0,0,.3), rgba(255,0,0,0.2) 70.71%)',
                backgroundImage: 'linear-gradient(#fdfbfb,#ebedee)',
                // linear-gradient(135deg, rgb(252, 253, 254), rgb(236, 239, 251), rgb(220, 225, 248))
                // backgroundColor: '#F8F8F8',   // background of post component F8F8F8
                width: '100%',
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                flexGrow: 1,
                // padding: theme.spacing.unit * 1,
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                height: 'calc(100% - 56px)'
            },
            // marginTop: 56,   // space if you use a non-transparent header
            _d[theme.breakpoints.up('sm')] = {
                height: 'calc(100% - 64px)',
                marginTop: 0,
            },
            _d),
        'content-left': {
            marginLeft: 0,
        },
        'content-right': {
            marginRight: 0,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        'contentShift-left': (_e = {
                marginLeft: 0
            },
            _e[theme.breakpoints.up('md')] = {
                marginLeft: 0 // controls how much content shifts when sidebar appears
            },
            _e),
        'contentShift-right': (_f = {
                marginRight: 0
            },
            _f[theme.breakpoints.up('md')] = {
                marginRight: 0 // controls how much content shifts when sidebar appears
            },
            _f)
    });
};
// - Create Home component class
var HomeComponent = /** @class */ (function (_super) {
    __extends(HomeComponent, _super);
    // private mount = React.createRef<HTMLDivElement>()
    // Constructor
    function HomeComponent(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Handle drawer toggle
         */
        _this.handleDrawerToggle = function () {
            _this.setState({ drawerOpen: !_this.state.drawerOpen });
        };
        // Default state
        _this.state = {
            drawerOpen: true
        };
        return _this;
        // Binding function to `this`
    }
    HomeComponent.prototype.componentWillMount = function () {
        var _a = this.props, global = _a.global, clearData = _a.clearData, loadData = _a.loadData, authed = _a.authed, defaultDataEnable = _a.defaultDataEnable, isVerifide = _a.isVerifide, goTo = _a.goTo;
        if (!authed) {
            goTo('/login');
            return;
        }
        if (!isVerifide) {
            goTo('/emailVerification');
        }
        else if (!global.get('defaultLoadDataStatus')) {
            clearData();
            loadData();
            defaultDataEnable();
        }
    };
    HomeComponent.prototype.componentDidMount = function () {
        if (this.props.firstTime) {
            this.props.openEditor();
        }
    };
    /**
     * Render DOM component
     *
     * @returns DOM
     *
     * @memberof Home
     */
    HomeComponent.prototype.render = function () {
        var _a;
        var HR = HomeRouter;
        var _b = this.props, loaded = _b.loaded, authed = _b.authed, loadDataStream = _b.loadDataStream, mergedPosts = _b.mergedPosts, hasMorePosts = _b.hasMorePosts, editProfileOpen = _b.editProfileOpen, showSendFeedback = _b.showSendFeedback, translate = _b.translate, classes = _b.classes, theme = _b.theme;
        var drawerOpen = this.state.drawerOpen;
        var style = {
            drawerStyle: {
                fontFamily: 'Apercu-Light',
                color: 'white',
                fontSize: '17px',
                letterSpacing: '1px'
            },
            iconColor: {
                color: 'white'
            }
        };
        var anchor = theme.direction === 'rtl' ? 'right' : 'left';
        var styles = {
            column: {
                float: 'left',
                width: '29%',
                padding: '.1%',
                margin: 'auto',
                marginTop: '3.5%',
            },
            columnmid: {
                float: 'left',
                width: '40%',
                padding: '5px',
            },
            row: {
                content: '',
                margin: 'auto',
                clear: 'both',
                display: 'table',
            }
        };
        return (React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.appFrame },
                React.createElement(Hidden, { mdUp: true },
                    React.createElement(Drawer, { variant: 'temporary', open: !this.state.drawerOpen, classes: {
                            paper: classes.drawerPaper,
                        }, onClose: this.handleDrawerToggle, ModalProps: {
                            keepMounted: true,
                        } },
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.drawerHeader }),
                            React.createElement(MenuList, { style: { color: 'rgb(117, 117, 117)', width: '210px' } },
                                React.createElement(Divider, null))))),
                React.createElement(Hidden, { smDown: true, implementation: 'js' },
                    React.createElement(Drawer, { variant: 'persistent', open: !this.state.drawerOpen, classes: {
                            paper: classes.drawerPaperLarge,
                        } },
                        React.createElement("div", null,
                            React.createElement(MenuList, { className: classes.menu, style: { color: 'rgb(117, 117, 117)', width: '210px' } })))),
                React.createElement("main", { className: classNames(classes.content, classes["content-" + anchor], (_a = {},
                        _a[classes.contentShift] = drawerOpen,
                        _a[classes["contentShift-" + anchor]] = drawerOpen,
                        _a)) },
                    React.createElement("div", { style: {} },
                        React.createElement(ImageCarousel, null)),
                    authed && editProfileOpen ? (React.createElement(EditProfile, { avatar: this.props.avatar, banner: this.props.banner, fullName: this.props.fullName })) : ''))));
    };
    return HomeComponent;
}(Component));
export { HomeComponent };
// - Map dispatch to props
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        openEditor: function () { return dispatch(userActions.openEditProfile()); },
        loadDataStream: function (page, limit) { return dispatch(postActions.dbGetPosts(page, limit)); },
        loadData: function () {
            dispatch(postActions.dbGetPosts());
            dispatch(imageGalleryActions.dbGetImageGallery());
            dispatch(userActions.dbGetUserInfo());
            dispatch(notifyActions.dbGetNotifications());
            dispatch(circleActions.dbGetCircles());
            dispatch(circleActions.dbGetUserTies());
            dispatch(circleActions.dbGetFollowers());
        },
        clearData: function () {
            dispatch(imageGalleryActions.clearAllData());
            dispatch(postActions.clearAllData());
            dispatch(userActions.clearAllData());
            dispatch(notifyActions.clearAllNotifications());
            dispatch(circleActions.clearAllCircles());
            dispatch(globalActions.clearTemp());
        },
        defaultDataDisable: function () {
            dispatch(globalActions.defaultDataDisable());
        },
        defaultDataEnable: function () {
            dispatch(globalActions.defaultDataEnable());
        },
        goTo: function (url) { return dispatch(push(url)); },
        showSendFeedback: function () { return dispatch(globalActions.showSendFeedback()); },
        hideSendFeedback: function () { return dispatch(globalActions.hideSendFeedback()); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid'], {});
    var global = state.get('global', {});
    var mergedPosts = Map({});
    var circles = state.getIn(['circle', 'circleList'], {});
    var followingUsers = state.getIn(['circle', 'userTies'], {});
    var Scene = state.getIn(['renderer', 'StateScene']);
    var Camera = state.getIn(['renderer', 'StateCamera']);
    var posts = state.getIn(['post', 'userPosts', uid], {});
    var hasMorePosts = state.getIn(['post', 'stream', 'hasMoreData'], true);
    var peopleInfo = state.getIn(['user', 'info']);
    followingUsers.forEach(function (user, userId) {
        var newPosts = state.getIn(['post', 'userPosts', userId], {});
        mergedPosts = mergedPosts.merge(newPosts);
    });
    mergedPosts = mergedPosts.merge(posts);
    var userProfile = state.getIn(['user', 'info', uid], {});
    return {
        authed: state.getIn(['authorize', 'authed'], false),
        isVerifide: state.getIn(['authorize', 'isVerifide'], false),
        translate: getTranslate(state.get('locale')),
        currentLanguage: getActiveLanguage(state.get('locale')).code,
        editProfileOpen: state.getIn(['user', 'openEditProfile']),
        mergedPosts: mergedPosts,
        peopleInfo: peopleInfo,
        fullName: userProfile.fullName,
        avatar: userProfile.avatar,
        banner: userProfile.banner,
        firstTime: userProfile.firstTime,
        global: global,
        hasMorePosts: hasMorePosts,
        loaded: state.getIn(['user', 'loaded']) && state.getIn(['imageGallery', 'loaded']) && state.getIn(['notify', 'loaded']) && state.getIn(['circle', 'loaded']),
        Camera: Camera,
        Scene: Scene
    };
};
// - Connect component to redux store
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(HomeComponent)));



//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/FrontPg.tsx
// module id = 1486
// module chunks = 0 1 2 3